var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"report"},[_c('div',{staticClass:"investor-nav tnavList"},[_c('router-link',{staticClass:"investor-nav-item",attrs:{"to":{name:'Overview'}}},[_vm._v("概述")]),_vm._v(" "),_c('router-link',{staticClass:"investor-nav-item",attrs:{"to":{name:'BoardMember'}}},[_vm._v("董事会成员")])],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc35d586","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/investor/CorporateGovernance.vue
// module id = null
// module chunks = 